let memail = '';
let mphone = '';
async function sha256(str) {
  const msgBuffer = new TextEncoder().encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');        
  return hashHex;
}
window.addEventListener("klaviyoForms", async function(e) {
  if (e.detail.type == 'stepSubmit') {
    memail = memail || e.detail.metaData && e.detail.metaData.$email;
    mphone = mphone || e.detail.metaData && e.detail.metaData.$phone_number;
    if(memail) {
      if(typeof TriplePixel == 'function') {
        TriplePixel('Contact', {email: e.detail.metaData.$email});
      }
    }
    if(mphone) {
      if(typeof TriplePixel == 'function') {
        TriplePixel('Contact', {phone: e.detail.metaData.$phone_number});
      }
    }
    if(memail && mphone) {
      if((typeof window.uetq != 'undefined') && (typeof window.uetq.push == 'function')) {
        window.uetq.push('set', { 'pid': { 
          'em': memail,
          'ph': mphone,
        } });
      }
      if((typeof ttq != 'undefined') && (typeof ttq.track === 'function')) {
        let hashed_email = await sha256(memail);
        let hashed_phone = await sha256(mphone);
        if(hashed_email && hashed_phone) {
          ttq.track('Contact', {
            user: {
              email: hashed_email,
              phone: hashed_phone
            }
          })
        }
      }
    }
  }
});